<template>
  <div class="main-content">
    <div>
      <v-card class="pl-3 pr-3 fs-card-topbar" outlined shaped tile>
        <v-row>
          <v-col md="3" style="min-width: 350px; max-width: 350px">
            <v-form autocomplete="off">
              <v-text-field
                @keydown.enter.prevent="pesquisar()"
                class="fs-searchfield"
                label="Pesquisar"
                placeholder=" "
                spellcheck="false"
                v-model="textoPesquisa"
                style="border-top-left-radius: 15px;"
                append-icon="mdi-magnify"
                @click:append="pesquisar()"
                outlined
                dense
              />
            </v-form>
          </v-col>
          <v-spacer></v-spacer>
          <v-col md="7">
            <div class="pt-2 pl-1 mb-1 fs-topbar-crud">
              <v-btn class="mb-2 fs-btns-crud-grid" @click="abrirModoInclusao()" outlined small>
                <v-icon class="mr-1">mdi-plus-box</v-icon>
                Incluir
              </v-btn>
              <v-btn
                :disabled="campanhaSelecionada.status === '3' || campanhaSelecionada.status === '4'"
                class="mb-2 fs-btns-crud-grid"
                @click="abrirModoEdicao()"
                outlined
                small
              >
                <v-icon class="mr-1">mdi-pen</v-icon>
                Editar
              </v-btn>
              <v-btn
                :disabled="campanhaSelecionada.status === '0' || campanhaSelecionada.status === '3' || campanhaSelecionada.status === '4'"
                class="mb-2 fs-btns-crud-grid"
                @click="cancelarCampanha()"
                color="red"
                outlined
                small
              >
                <v-icon class="ml-n1">mdi-close</v-icon>
                Cancelar
              </v-btn>
              <v-btn
                :disabled="campanhaSelecionada.status === '3' || campanhaSelecionada.status === '4'"
                class="mb-2 fs-btns-crud-grid"
                @click="programarCampanha()"
                outlined
                small
              >
                <v-icon class="ml-n1 mr-1">mdi-calendar</v-icon>
                Programar Envio
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-card>

      <v-card class="mt-2" height="400px" outlined tile>
        <v-data-table
          style="border-bottom: 1px solid #E0E0E0"
          height="400px"
          :loading="loading"
          loading-text="Carregando, aguarde..."
          :headers="headers"
          :items="campanhas.data"
          :items-per-page="999"
          hide-default-footer
          hide-action
          item-key="id"
        >
          <template v-slot:body="{ items }">
            <tr
              v-show="item.tipo === '1'"
              :class="item === campanhaSelecionada ? 'fs-row-campanha-selec' : ''"
              v-for="item in items"
              :key="item.id"
            >
              <td @click="setCampanhaSelecionada(item)">
                {{ item.campanha }}
              </td>
              <td @click="setCampanhaSelecionada(item)">
                {{ item.assunto }}
              </td>
              <td @click="setCampanhaSelecionada(item)">
                {{ formatarDataHora(item.created_at, 'DD/MM/YYYY HH:mm') }}
              </td>
              <td @click="setCampanhaSelecionada(item)">
                <b>
                  {{ formatarDataHora(item.dthr_programacao, 'DD/MM/YYYY') }}
                </b>
              </td>
              <td @click="setCampanhaSelecionada(item)">
                <v-chip
                  v-if="item.status === '0'"
                  color="default"
                  small
                >
                  Não Programada
                </v-chip>
                <v-chip
                  v-else-if="item.status === '1'"
                  color="success"
                  small
                >
                  Programada
                </v-chip>
                <v-chip
                  v-else-if="item.status === '2'"
                  color="primary"
                  small
                >
                  Iniciada
                </v-chip>
                <v-chip
                  v-else-if="item.status === '3'"
                  color="warning"
                  small
                >
                  Finalizada
                </v-chip>
                <v-chip
                  v-else-if="item.status === '4'"
                  color="error"
                  small
                >
                  Cancelada
                </v-chip>
              </td>
              <td @click="setCampanhaSelecionada(item)">
                <v-chip
                  v-if="item.enviar_whatsapp === 'S'"
                  color="success"
                  small
                >
                  Sim
                </v-chip>
                <v-chip
                  v-else
                  color="error"
                  small
                >
                  Não
                </v-chip>
              </td>
              <td>
                <v-btn
                  @click="dialogEmail = true; campanhaSelecionada = item"
                  icon
                >
                  <v-icon color="primary">
                    mdi-email
                  </v-icon>
                </v-btn>
              </td>
              <td>
                <v-btn
                  :disabled="campanhaSelecionada.status === '3'"
                  @click="excluirCampanha(item)"
                  icon
                >
                  <v-icon color="error">
                    mdi-delete
                  </v-icon>
                </v-btn>
              </td>
              <td v-if="loggedInUser.id === 1 || loggedInUser.id === 2 || loggedInUser.id === 3">
                <v-btn
                  @click="enviarCampanha(item)"
                  icon
                >
                  <v-icon color="primary">
                    mdi-send
                  </v-icon>
                </v-btn>
              </td>
            </tr>
            <div
              v-if="campanhas.data && !campanhas.data.length"
              class="mt-5"
              style="text-align: center; position: absolute; width: 100%; color: gray"
            >
              <v-icon class="mt-n1 mr-1">
                mdi-alert
              </v-icon>
              Não há campanhas cadastradas, para começar clique no botão Incluir...
            </div>
          </template>
        </v-data-table>
      </v-card>
    </div>

    <v-dialog v-model="dialog" width="720px">
      <v-form
        ref="form"
        v-model="valid"
        lazy-validation
        autocomplete="off"
      >
        <v-card>
          <v-card-title class="pb-2" style="background-color: #EEEEEE">
            <v-row no-gutters>
              <span v-if="!modoEdicao">
                Incluir Campanha
              </span>
              <span v-else>
                Editar Campanha
              </span>
              <v-spacer></v-spacer>
              <v-btn class="mr-n1" @click="dialog = false" small icon>
                <v-icon color="red">
                  mdi-close
                </v-icon>
              </v-btn>
            </v-row>
          </v-card-title>
          <v-divider/>
          <v-card-text>
            <v-row no-gutters>
              <v-col md="8">
                <v-text-field
                  label="Nome da Campanha *"
                  v-model="novaCampanha.campanha"
                  spellcheck="false"
                  :rules="requiredRules"
                  placeholder=" "
                  hide-details
                  outlined
                  dense
                />
              </v-col>
              <v-col md="4">
                <v-menu
                  v-model="menuData"
                  :close-on-content-click="false"
                  :nudge-top="48"
                  :nudge-right="10"
                  transition="scale-transition"
                  offset-y
                >
                  <template v-slot:activator="{ on }">
                    <!-- CAMPANHAS JÁ PROGRAMADAS NÃO PODE TER A DATA DE ENVIO ALTERADA -->
                    <v-text-field
                      class="ml-3"
                      :value="formatData"
                      spellcheck="false"
                      append-outer-icon="mdi-calendar"
                      label="Data de Envio *"
                      :rules="requiredRules"
                      placeholder=" "
                      @click:clear="novaCampanha.dthr_programacao = null"
                      hide-details
                      v-on="on"
                      outlined
                      readonly
                      dense
                    ></v-text-field>
                  </template>
                  <!-- <v-date-picker
                    v-model="novaCampanha.dthr_programacao"
                    @change="menuData = false"
                  ></v-date-picker> -->
                  <v-date-picker
                    v-model="novaCampanha.dthr_programacao"
                    @change="menuData = false"
                    :min="retornaDataMinima()"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col md="6">
                <v-text-field
                  label="Assunto *"
                  v-model="novaCampanha.assunto"
                  :rules="requiredRules"
                  spellcheck="false"
                  class="mt-3"
                  placeholder=" "
                  hide-details
                  outlined
                  dense
                />
              </v-col>
              <v-col md="6">
                <v-select
                  label="Enviar WhatsApp"
                  v-model="novaCampanha.enviar_whatsapp"
                  spellcheck="false"
                  height="32px"
                  :items="[{ value: 'S', text: 'Sim' }, { value: 'N', text: 'Não' }]"
                  item-text="text"
                  item-value="value"
                  class="mt-3 ml-3"
                  placeholder=" "
                  hide-details
                  outlined
                  dense
                />
              </v-col>
            </v-row>
            <v-file-input
              label="Imagem (Upload p/S3 na AWS)"
              spellcheck="false"
              id="upload"
              accept="image/png, image/jpeg, image/bmp"
              v-model="file"
              @change="mostrarImagem()"
              ref="fileInput"
              class="mt-3"
              append-outer-icon="mdi-camera"
              prepend-icon=""
              placeholder=" "
              hide-details
              outlined
              dense
            >
            </v-file-input>
            <img
              v-if="modoEdicao && campanhaSelecionada.imagem_url"
              :src="campanhaSelecionada.imagem_url"
              class="fs-img-campanha mb-2"
              alt=""
            >
            <img
              v-else
              :src="imagemTmp"
              class="fs-img-campanha mb-2"
              alt=""
            >
            <br>
            <v-row no-gutters>
              <label for="">
                Conteúdo HTML *
              </label>
              <v-spacer/>
              <v-btn @click="dialogActions = true" class="mt-n1 primary" height="18px" small>
                Legenda de Actions
              </v-btn>
            </v-row>
            <div v-if="mostrarEditorHtml">
              <textarea
                class="box-html"
                spellcheck="false"
                v-model="novaCampanha.conteudo_html"
                rows="15"
                cols="109"
              >
                It was a dark and stormy night...
              </textarea>
            </div>
            <vue-editor
              v-else
              class="fs-vue-editor"
              :editorToolbar="customToolbar"
              spellcheck="false"
              v-model="novaCampanha.conteudo_html"
            />
            <!-- {{ novaCampanha.conteudo_html }} -->
            <!-- {{ novaCampanha.conteudo_texto }} -->
          </v-card-text>
          <v-card-actions class="mx-2 pb-4">
            <v-btn
              @click="mostrarEditorHtml = !mostrarEditorHtml"
              color="success"
              small
            >
              {{ !mostrarEditorHtml ? 'Alterar p/ Editor HTML' : 'Alterar p/ Editor Padrão' }}
            </v-btn>
            <v-btn
              @click="carregarTemplatePadrao()"
              color="warning"
              small
            >
              Carregar Template Padrão
            </v-btn>
            <v-spacer />
            <v-btn
              @click="salvarCampanha()"
              color="primary"
              small
            >
              Salvar Campanha
            </v-btn>
            <v-btn
              @click="dialog = false"
              color="error"
              small
            >
              Cancelar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <v-dialog v-model="dialogActions" width="420px">
      <v-card width="420px">
        <v-card-title>
          Legenda de Actions
        </v-card-title>
        <v-card-text style="font-size: 13px">
          As actions disponíveis para uso no template de e-mail são as seguintes:
          <table class="mt-2" style="width: 100%; font-size: 11px">
            <thead>
              <tr>
                <td><b>ACTION</b></td>
                <td><b>DESCRIÇÃO</b></td>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(action, index) in actions" :key="index">
                <td>{{ action.key }}</td>
                <td>{{ action.desc }}</td>
              </tr>
            </tbody>
          </table>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogEmail" width="420px">
      <v-card width="420px">
        <v-card-title>
          Enviar E-mail de Exemplo
        </v-card-title>
        <v-card-text>
          Escolha o tipo do produto e informe um e-mail válido para receber um exemplo com o template que será enviado na campanha.
          <v-select
            autofocus
            class="mt-4"
            :items="grupos"
            v-model="grupoEmailExemplo"
            label="Tipo de Produto"
            item-text="grupo_descricao"
            item-value="produto_grupo_id"
            placeholder="Selecione"
            :disabled="loading"
            height="33px"
            hide-details
            outlined
            dense
          />
          <v-text-field
            spellcheck="false"
            class="mt-3"
            v-model="emailEnvioTemplate"
            label="E-mail"
            placeholder="Preencha seu e-mail"
            :disabled="loading"
            hide-details
            outlined
            dense
          />
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer/>
          <v-btn
            :loading="loading"
            :disabled="loading"
            color="primary"
            small
            @click="enviarEmail"
          >
            <v-icon small class="mr-2">
              mdi-email
            </v-icon>
            ENVIAR EMAIL
            <!-- Faz um css do loading -->
            <template v-slot:loader>
              Enviando...
              <span class="custom-loader">
                <v-icon color="red">mdi-fan</v-icon>
              </span>
            </template>
          </v-btn>
          <v-btn
            color="error"
            dark
            small
            :disabled="loading"
            @click="dialogEmail = false"
          >
            <v-icon small class="mr-2">
              mdi-close-circle
            </v-icon>
            FECHAR
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-overlay :value="loading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from 'vuex'
import { VueEditor } from 'vue2-editor'
import { list, list2, add, get, edit, del } from '@/api/crud' // eslint-disable-line
import { uploadImagem, programarEnvio, enviarEmailExemplo, enviarCampanhaExemplo } from '@/api/campanha'

import moment from 'moment'

export default {
  components: {
    VueEditor
  },
  data () {
    return {
      actions: [
        { key: '{{ultima_nota}}', desc: 'Número da última NFe emitida para o cliente.' },
        { key: '{{data}}', desc: 'Data da última NFe emitida para o cliente.' },
        { key: '{{empresa}}', desc: 'Razão Social do cliente.' },
        { key: '{{contato}}', desc: 'Nome do Contato responsável pela empresa.' },
        { key: '{{produto}}', desc: 'Descrição do Produto comprado pelo cliente.' },
        { key: '{{cnpj}}', desc: 'CNPJ do cliente.' },
        { key: '{{email}}', desc: 'E-mail do cliente.' },
        { key: '{{whatsapp}}', desc: 'WhatsApp do cliente.' },
        { key: '{{site}}', desc: 'Site da Fortkol em formato de link.' }
      ],
      headers: [
        { text: 'CAMPANHA', value: 'campanha' },
        { text: 'ASSUNTO', value: 'assunto' },
        { text: 'DATA-GERAÇÃO', value: 'created_at' },
        { text: 'DATA-PROGRAMAÇÃO', value: 'dthr_programacao' },
        { text: 'STATUS', value: 'status' },
        { text: 'ENVIAR WHATSAPP', value: 'enviar_whatsapp' },
        { text: 'EXEMPLO' },
        { text: 'EXCLUIR' }
      ],
      novaCampanha: {
        dthr_programacao: moment().add(0, 'days').format('YYYY-MM-DD'),
        conteudo_html: ''
      },
      requiredRules: [
        v => !!v || 'Esse campo é obrigatório!'
      ],
      dialogActions: false,
      dialogEmail: false,
      emailEnvioTemplate: '',
      file: null,
      mostrarEditorHtml: false,
      imagemTmp: require('@/assets/imagem-indisponivel.png'),
      modoEdicao: false,
      campanhaSelecionada: {},
      menuData: false,
      dialog: false,
      grupos: [],
      grupoEmailExemplo: null,
      textoPesquisa: '',
      campanhas: [],
      campanhasOriginal: [],
      loading: true,
      valid: true,
      // Ferramentas habilitadas no toolbar do editor de HTML
      customToolbar: [
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        ['bold', 'italic', 'underline', 'strike'],
        [
          { align: '' },
          { align: 'center' },
          { align: 'right' },
          { align: 'justify' }
        ],
        ['blockquote', 'code-block'],
        [{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }],
        [{ indent: '-1' }, { indent: '+1' }],
        [{ color: [] }, { background: [] }],
        // ['link', 'image', 'video'],
        ['clean']
      ]
    }
  },
  computed: {
    ...mapGetters('authData', ['loggedInUser']),
    ...mapState({
      confirm: state => state.global.confirm
    }),
    formatData () {
      return this.novaCampanha.dthr_programacao ? moment(this.novaCampanha.dthr_programacao).format('DD/MM/YYYY') : ''
    }
  },
  mounted () {
    // console.log(this.$vuetify.breakpoint)
    this.getDataFromApi()
    this.buscarGrupos()
  },
  methods: {
    ...mapMutations({
      setSnackbar: 'global/setSnackbar',
      setCampanha: 'campanha/setCampanhaSelec'
    }),
    async enviarCampanha (campanha) {
      this.loading = true
      if (await this.confirm.open('Enviar Campanha', `Tem certeza que deseja enviar a campanha "${campanha.campanha}"?`, { color: 'red' })) {
        try {
          await enviarCampanhaExemplo(campanha.id)
          this.setSnackbar({ msg: 'Campanha Enviada com Sucesso!', color: 'success' })
        } catch (error) {
          this.setSnackbar({ msg: error, color: 'red' })
        }
      }
      this.loading = false
    },
    retornaDataMinima () {
      return moment().add(1, 'days').format('YYYY-MM-DD')
    },
    async buscarGrupos () {
      const { data } = await list('/site/grupos')
      this.grupos = data.filter(item => {
        if (item.id === 1 || item.id === 2 || item.id === 3 || item.id === 4) return item
      })
    },
    pesquisar () {
      this.campanhas.data = this.campanhasOriginal.data.filter(item => {
        if (item.campanha.indexOf(this.textoPesquisa) !== -1) return item
      })
    },
    setCampanhaSelecionada (item) {
      this.campanhaSelecionada = item
      this.setCampanha(item)
    },
    async mostrarImagem () {
      if (this.file) this.imagemTmp = URL.createObjectURL(this.file)
    },
    abrirModoInclusao () {
      this.modoEdicao = false
      this.imagemTmp = require('@/assets/imagem-indisponivel.png')
      this.file = null
      this.novaCampanha = {
        dthr_programacao: moment().add(1, 'days').format('YYYY-MM-DD'),
        enviar_whatsapp: 'S'
      }
      this.dialog = true
    },
    abrirModoEdicao () {
      if (this.campanhaSelecionada) {
        this.file = null
        this.imagemTmp = require('@/assets/imagem-indisponivel.png')
        this.novaCampanha = Object.assign({}, this.campanhaSelecionada)
        this.novaCampanha.dthr_programacao = moment(this.campanhaSelecionada.dthr_programacao).format('YYYY-MM-DD')
        this.modoEdicao = true
        this.dialog = true
      } else {
        this.setSnackbar({ msg: 'Selecione a Campanha que deseja editar!', color: 'red' })
      }
    },
    async programarCampanha () {
      if (this.campanhaSelecionada) {
        if (await this.confirm.open('Programar Envio', `Tem certeza que deseja programar o envio da campanha "${this.campanhaSelecionada.campanha}"?`, { color: 'red' })) {
          this.loading = true
          try {
            const res = await programarEnvio(this.campanhaSelecionada.id)
            await this.getDataFromApi()
            if (res.message) {
              this.setSnackbar({ msg: res.message, color: 'error' })
            } else {
              this.setSnackbar({ msg: 'Campanha Programada com Sucesso!', color: 'success' })
            }
          } catch (error) {
            this.setSnackbar({ msg: error, color: 'red', timeout: 7000 })
          }
        }
      } else {
        this.setSnackbar({ msg: 'Selecione a Campanha que deseja programar o envio!', color: 'red' })
      }
    },
    validate () {
      return this.$refs.form.validate()
    },
    async getDataFromApi () {
      this.loading = true
      const filtro = [{ field: 'tipo', value: '1' }]
      this.campanhas = await list2('/crm/campanhasfiltro', { tipo: 'filtro', query: this.querySerializePesquisa('filtro', filtro) })
      // console.log(this.campanhas)
      this.campanhasOriginal = Object.assign({}, this.campanhas)
      if (this.campanhas && this.campanhas.data.length > 0) {
        this.setCampanhaSelecionada(this.campanhas.data[0])
      }
      // console.log(this.campanhas)
      this.loading = false
    },
    formatarDataHora (data, format) {
      return moment(data).format(format)
    },
    async salvarCampanha () {
      // console.log(this.modoEdicao)
      this.pegarTextoPuroEditor()
      const obj = Object.assign({}, this.novaCampanha)
      if (this.validate()) {
        if (this.novaCampanha.conteudo_html) {
          if (!this.modoEdicao) {
            try {
              this.dialog = false
              const res = await add('/crm/campanhas', 'add', obj)
              this.fazerUploadImagem(res.id)
              this.getDataFromApi()
              this.setSnackbar({ msg: 'Campanha inclusa com sucesso!', color: 'success' })
            } catch (error) {
              this.setSnackbar({ msg: error, color: 'red', timeout: 7000 })
            }
          } else {
            // UPDATE
            try {
              this.dialog = false
              const res = await edit('/crm/campanhas', 'edit', obj.id, obj)
              this.fazerUploadImagem(res.id)
              this.getDataFromApi()
              this.setSnackbar({ msg: 'Campanha atualizada com sucesso!', color: 'success' })
            } catch (error) {
              this.setSnackbar({ msg: error, color: 'red', timeout: 7000 })
            }
          }
        }
        this.setSnackbar({ msg: 'O campo "Conteúdo HTML" é obrigatório!', color: 'red', timeout: 7000 })
      } else {
        this.setSnackbar({ msg: 'Verifique os campos informados e tente novamente!', color: 'red', timeout: 7000 })
      }
      this.modoEdicao = false
    },
    async cancelarCampanha () {
      if (this.campanhaSelecionada) {
        if (this.campanhaSelecionada.status === '1') {
          if (await this.confirm.open('Cancelar Campanha', `Tem certeza que deseja cancelar a campanha "${this.campanhaSelecionada.campanha}"?`, { color: 'red' })) {
            try {
              await edit('/crm/campanhas', 'edit', this.campanhaSelecionada.id, { status: '4' })
              this.getDataFromApi()
              this.setSnackbar({ msg: 'Campanha cancelada com sucesso!', color: 'success' })
            } catch (error) {
              this.setSnackbar({ msg: error, color: 'red', timeout: 7000 })
            }
          }
        } else {
          this.setSnackbar({ msg: 'A campanha selecionada não pode ser cancelada!', color: 'red' })
        }
      } else {
        this.setSnackbar({ msg: 'Selecione a Campanha que deseja cancelar!', color: 'red' })
      }
    },
    async excluirCampanha (campanha) {
      if (await this.confirm.open('Excluir Campanha', `Tem certeza que deseja excluir a campanha "${campanha.campanha}"?`, { color: 'red' })) {
        try {
          await del('/crm/campanhas', 'del', campanha.id)
          location.reload()
          // await this.getDataFromApi()
          // this.setCampanhaSelecionada(null)
          // this.setSnackbar({ msg: 'Campanha excluída com sucesso!', color: 'success' })
        } catch (error) {
          this.setSnackbar({ msg: error, color: 'red', timeout: 7000 })
        }
      }
    },
    async enviarEmail () {
      this.loading = true
      if (this.emailEnvioTemplate.length > 5) {
        const obj = {
          grupo: this.grupoEmailExemplo,
          campanhaid: this.campanhaSelecionada.id,
          email: this.emailEnvioTemplate
        }
        const res = await enviarEmailExemplo(obj)
        if (res.msg) {
          this.setSnackbar({ msg: res.msg, color: 'red', timeout: 7000 })
        } else {
          this.setSnackbar({ msg: 'E-mail enviado com Sucesso!', color: 'success' })
        }
        this.dialogEmail = false
      } else {
        this.setSnackbar({ msg: 'Informe um e-mail válido!', color: 'red', timeout: 7000 })
      }
      this.loading = false
    },
    querySerializePesquisa (nome, filtroComposto) {
      let query = ''
      for (let i = 0; i < filtroComposto.length; i++) {
        if (i === 0) {
          query = query + nome + '%5B0%5D' + '=' + '%5B' + encodeURIComponent(JSON.stringify(filtroComposto[i]))
        } else {
          query = query + encodeURIComponent(',') + encodeURIComponent(JSON.stringify(filtroComposto[i]))
        }
      }
      return query + '%5D'
    },
    async fazerUploadImagem (campanhaId) {
      if (this.file) {
        const fileFormData = new FormData()
        fileFormData.append('filename', this.file)
        try {
          await uploadImagem(fileFormData, campanhaId)
        } catch (e) {
          this.setSnackbar({ msg: 'Ocorreu um erro ao fazer upload!', color: 'red', timeout: 4000 })
        }
      }
    },
    async carregarTemplatePadrao () {
      if (await this.confirm.open('Carregar Template Padrão', 'Tem certeza que deseja carregar o template padrão?', { color: 'red' })) {
        this.novaCampanha.conteudo_html = '<p>Sr(a) <strong style="letter-spacing: 0.00714286em;">{{contato}}</strong>, boa tarde.</p><p><br></p><p class="ql-align-justify">De acordo com nosso sistema sua última compra realizada de {{produto}} conosco foi em {{data}} e, levando em consideração sua média de consumo, acreditamos que será necessário o recebimento de um novo pedido no próximo mês.</p><p class="ql-align-justify"><br></p><p class="ql-align-justify">Com a alta do dólar e a atual inconstância no mercado mundial que estamos vivenciando, nos deparamos com dois cenários:</p><p><br></p><p class="ql-align-justify">1º - Altas chances de realizar um novo ajuste em nossa tabela de valores nos próximos dias em função da oscilação do dólar, para assim mantermos o mesmo padrão de qualidade dos nossos materiais.</p><p class="ql-align-justify">2º - Uma enorme gama de empresas retomando as atividades ao mesmo tempo e em consequência disto realizando pedidos para recebimento urgente.</p><p><br></p><p><strong>BENEFÍCIOS DE REALIZAR SUA RESERVA/PROGRAMAÇÃO:</strong></p><ol><li>Garantir os valores e condições comerciais atuais.</li><li>Certeza de receber o material na data que necessita.</li><li>Os boletos só começarão a contar após faturar seu pedido.</li><li>A programação não terá nenhum custo adicional.</li></ol><p><br></p><p><strong>RISCOS DE NÃO REALIZAR A PROGRAMAÇÃO/RESERVA:</strong></p><ol><li>Pagar um acréscimo no valor do produto entre <strong>18% a 25% </strong>após o reajuste.</li><li>Possibilidade de esgotamento total de seu estoque e assim não conseguirmos lhe entregar antes do prazo.</li><li>Risco de esgotamento de nossas horas máquinas e ter que entrar em fila de espera.</li></ol><p>          </p><p class="ql-align-justify">Mediante este cenário, gostaríamos de saber se você deseja programar seu novo pedido a fim de garantir as condições atuais e a entrega na data correta conforme sua necessidade?</p>'
        this.mostrarEditorHtml = !this.mostrarEditorHtml
      }
    },
    pegarTextoPuroEditor () {
      let str = this.novaCampanha.conteudo_html.slice()
      // console.log(str)
      // AJUSTA AS QUEBRAS DE LINHA
      str = str.replace(/<br>/g, ' ')
      str = str.replace(/<\/p>/g, ' ')
      str = str.replace(/<\/h1>/g, ' ')
      str = str.replace(/<\/h2>/g, ' ')
      str = str.replace(/<\/h3>/g, ' ')
      str = str.replace(/<\/h4>/g, ' ')
      str = str.replace(/<\/h5>/g, ' ')
      str = str.replace(/<\/h6>/g, ' ')
      const flag2 = /(<([^>]+)>)/ig
      this.novaCampanha.conteudo_texto = str.replace(flag2, '')
      // console.log(this.novaCampanha.conteudo_texto)
    }
  }
}
</script>

<style scoped>
.fs-vue-editor {
  height: 320px;
  max-height: 320px;
  transform: scale(0.8);
  transform-origin: left;
  margin-top: -28px;
  width: 125%;
}
#fs-row {
  border-bottom: 1px solid rgba(0,0,0,.12);
}
#fs-row:hover {
  cursor: pointer;
  background-color: rgba(238, 238, 238, 0.712);
}
.fs-searchfield .v-input__icon--append .v-icon {
  margin-top: -6px;
  font-size: 23px !important;
}
.fs-searchfield .v-input__icon--append .v-icon:hover {
  color: black;
}
textarea:focus, input:focus, select:focus, button:focus {
  box-shadow: 0 0 0 0;
  border: 0;
  outline: 0;
}
.row-destaque {
  font-weight: bold;
  border-left: 5px solid red;
}
.fs-btn-limit {
  font-size: 11px !important;
}
.v-input--selection-controls.v-input .v-label {
  padding-top: 9px !important;
  font-size: 12px !important;
}
.fs-topbar-crud {
  text-align: right;
  margin-top: -3px;
}
.fs-btns-crud-grid {
  padding: 3px 7px 3px 7px !important;
  margin-left: 10px;
}
.fs-btns-crud-grid:active {
  border: 1px solid rgb(122, 122, 122) !important;
}
.fs-card-topbar {
  height: 62px;
  border-bottom-right-radius: 0px;
}
.fs-img-campanha {
  margin-top: 12px;
  width: 220px;
  max-width: 220px;
  height: 120px;
  max-height: 120px;
  border: 1px solid rgb(185, 185, 185);
  border-radius: 4px;
}
.fs-row-campanha-selec {
  background-color: rgba(253, 210, 182, 0.432);
}
.box-html {
  margin-top: 3px;
  border: 1px solid rgb(182, 182, 182) !important;
  color: gray;
  font-size: 12px;
  padding: 7px;
  border-radius: 3px;
}
</style>
